module.exports = __webpack_public_path__ + "static/media/Bord.27b2d07d.PNG";